<div class="flex flex-col h-full">
    <rax-users-user-side-menu>
        <rax-app-toolbar />
        <div class="busy-indicator-container h-full">
            <rax-busy-indicator style="z-index: 500" />
            <router-outlet />
        </div>
    </rax-users-user-side-menu>
</div>
